import { Autocomplete, TextField } from '@mui/material';
import React, { useState, useEffect, useMemo } from 'react';

export const SearchSelect = ({ label, name, value, onChange, optionList = [], error = undefined, helperText = undefined, required = undefined, ...rest }) => {

  // 1. Memorizamos la lista para que la referencia sea estable
  const options = useMemo(() => {
    const selectOne = { value: 0, label: 'Seleccione...' };
    return [selectOne, ...optionList];
  }, [optionList]);

  // 2. Estado inicial buscando en la lista estable
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputValue, setInputValue] = useState('');

  // 3. Sincronizar cuando el valor externo cambia o la lista carga
  useEffect(() => {
    const found = options.find(elem => elem.value === value) || options[0];
    setSelectedValue(found);
  }, [value, options]);

  return (
    <Autocomplete
      id={`auto-complete-${name}`}
      // Importante: Autocomplete usa el objeto completo, no solo el ID
      value={selectedValue}
      options={options}
      // Esta función es vital para que reconozca cuál está seleccionado
      isOptionEqualToValue={(option, val) => option.value === val?.value}
      getOptionLabel={(option) => option.label || ''}
      onChange={(e, newValue) => {
        // Si el usuario borra la selección (X), ponemos el default (Seleccione...)
        const finalValue = newValue || options[0];
        setSelectedValue(finalValue);

        // Notificamos al padre con el formato que espera
        if (typeof onChange === 'function') {
          onChange({ target: { name, value: finalValue.value } });
        }
      }}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label={label}
          error={error}
          helperText={helperText}
          required={required}
        />
      )}
      fullWidth
      blurOnSelect
      {...rest}
    />
  );
};



// export const SearchSelect = ({ label, name, value, onChange, optionList=[], error=undefined, helperText=undefined, required=undefined, ...rest }) => {

//   const selectOne = [{value: 0, label: 'Seleccione...'}];
//   const options = [...selectOne, ...optionList];
//   const [selectedValue, setSelectedValue] = useState(options.find(elem=>elem.value===value) || options[0]);
//   const [inputValue, setInputValue] = useState('');

//   useEffect(()=>{
//     if(selectedValue){
//       onChange({target:{name, value: selectedValue.value}});
//     }else{
//       setSelectedValue(options[0]);
//       onChange({target:name, value: options[0]?.value});
//     }
//   }, [selectedValue]);

//   useEffect(()=>{
//     setSelectedValue(options.find(elem=>elem.value===value) || options[0]);
//   }, [value])

//   return (
//     <Autocomplete
//       id={`auto-complete-${name}`}
//       name={`auto-complete-${name}`}
//       value={selectedValue||null}
//       inputValue={inputValue}
//       options={options}
//       defaultValue={0}
//       onChange={(e, newValue) => {
//         setSelectedValue(newValue);
//       }}
//       onInputChange={(e, newInputValue) => {
//         setInputValue(newInputValue);
//       }}
//       isOptionEqualToValue={(option, value) => option.id === value.id}
//       renderInput={(params) => <TextField {...params} variant="standard" label={label} error={error} helperText={helperText} required={required}
//       />}
//       fullWidth
//       blurOnSelect
//       {...rest}
//     />
//   )
// }
